import {useEffect} from '@wordpress/element';

export const useProcessPaymentFailure = (
    {
        event,
        onError = null,
        responseTypes,
        messageContext = null,
        paymentMethodId,
        activePaymentMethod,
    }) => {
    useEffect(() => {
        const unsubscribe = event((data) => {
            if (data?.processingResponse?.paymentDetails?.braintreeErrorMessage) {
                const message = data.processingResponse.paymentDetails.braintreeErrorMessage;
                return {
                    type: responseTypes.ERROR,
                    message,
                    messageContext
                }
            }
            if (onError && activePaymentMethod === paymentMethodId) {
                onError('');
            }
            return null;
        });
        return () => unsubscribe();
    }, [event, onError, paymentMethodId, activePaymentMethod]);
}

export default useProcessPaymentFailure;